import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationReleasePost = {
    path: "/release",
    method: ERouteHttpVerb.POST
};
export { routeLocationReleasePost };
